import { useEffect, useState } from 'react';

export type Nav = (to: string) => void;

export const useHashRoute = (): [string, Nav] => {
  const [route, setRoute] = useState<string>(() =>
    typeof window !== 'undefined' ? window.location.hash.slice(1) || 'home' : 'home',
  );

  useEffect(() => {
    const onHash = () => setRoute(window.location.hash.slice(1) || 'home');
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const nav: Nav = (to) => {
    window.location.hash = to;
  };

  return [route, nav];
};
